// Port of api/fuel/app/classes/controller/api/monty/community/patreon.php
import Group from 'offline/model/group'
import User from 'offline/model/user'

function counts() {
	var users = User.collection({
		where: [
			['user_date_sync', '>', 0]
		]
	})
	var registered = 0
	var games = 0
	var ratings = 0
	var plays = 0

	for (var i = 0; i < users.length; i++) {
		registered += parseInt(users[i].get_status(), 10) || 0
		games += parseInt(users[i].get_count_collection(), 10) || 0
		ratings += parseInt(users[i].get_count_ratings(), 10) || 0
		plays += parseInt(users[i].get_count_plays(), 10) || 0
	}

	return {
		usernames: users.length,
		registered: registered,
		groups: Group.total(),
		games: games,
		ratings: ratings,
		plays: plays
	}
}

export default function() {
	return Promise.resolve({
		session: { offline: true },
		data: counts()
	})
}
